import './footer.scss';
import state from '../../state';
import FooterList from './FooterList';
function Footer() {
   let date = new Date().getFullYear();
   let FooterItem = state.FooterList.map ((col, idx) =>
   { 
      function openFooterMenu(idCol, id) {
         let  btn = document.getElementById(idCol),
               list = document.getElementById(id),
               active = document.querySelector('.active-footer'),
               title_active = document.querySelector('.title-active-footer');
         if (active && (active != list)) {
            active.classList.remove('active-footer')
         }
         if (title_active && (title_active != btn) ) {
            title_active.classList.remove('title-active-footer');
         }
         list.classList.toggle('active-footer');
         btn.classList.toggle('title-active-footer');  
      }
      return ( 
      <div  key={idx} className="col">
         <div className="title" id={col[0].idCol}  onClick={()=>openFooterMenu(col[0].idCol, col[0].id )}>{col[0].title}</div>
         <FooterList  list={col} />
      </div>
      )
   });
   return (
      <footer className="footer">
         <div className="footer__wrapper">
            <div className="footer__row">
               <div className="footer__block-hello">
                  <div className="footer__logo">
                     <a className="footer__logo-link link" target="_blank" rel="noreferrer"  href="https://www.pult.ru/">
                        <img  className="pic" src= "/img/LOGO.png" alt= "PULT.RU"></img>
                     </a>
                  </div>
                  <div className="footer__call">
                     <div className="call">
                     <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.605 4.3918C19.7463 -1.46517 10.2488 -1.46377 4.3918 4.39502C-1.46517 10.2538 -1.46377 19.7513 4.39502 25.6082C10.2538 31.4652 19.7513 31.4638 25.6082 25.605C28.4211 22.7913 30.0009 18.9754 30 14.9968C29.9992 11.0189 28.4183 7.20418 25.605 4.3918ZM22.717 20.8948C22.7164 20.8955 22.7157 20.8962 22.715 20.8968V20.8919L21.955 21.6468C20.9721 22.6422 19.5406 23.0517 18.18 22.7268C16.8092 22.3599 15.506 21.7759 14.32 20.9969C13.2181 20.2926 12.1969 19.4694 11.275 18.5418C10.4267 17.6998 9.66465 16.7752 8.99996 15.7818C8.27293 14.713 7.69748 13.5486 7.28996 12.3218C6.8228 10.8806 7.20992 9.29926 8.28998 8.23684L9.17996 7.34686C9.42741 7.0983 9.82948 7.09742 10.078 7.34487C10.0786 7.34551 10.0793 7.34615 10.08 7.34686L12.8899 10.1568C13.1385 10.4043 13.1394 10.8064 12.8919 11.0548C12.8913 11.0555 12.8906 11.0561 12.8899 11.0568L11.2399 12.7068C10.7665 13.1751 10.707 13.9193 11.1 14.4569C11.6967 15.2759 12.3572 16.0466 13.075 16.7619C13.8753 17.5657 14.7454 18.2969 15.675 18.9469C16.2121 19.3215 16.9403 19.2584 17.4049 18.7969L18.9999 17.1769C19.2474 16.9283 19.6494 16.9275 19.8979 17.1749C19.8986 17.1755 19.8992 17.1762 19.8999 17.1769L22.7149 19.9969C22.9636 20.2443 22.9644 20.6463 22.717 20.8948Z" fill="#343741"/>
                     </svg>
                     <p className="footer__call-text">Бесплатный по России</p>
                     </div>
                     <a className="footer__tel link " href="tel:+78005555152"   rel="noreferrer" target="_blank">8&nbsp;800&nbsp;555-51-52</a>
                  </div>
               </div>
               <div className="footer__col">
                  {FooterItem}
               </div>
            </div>
            
            <p className="footer__copyright">
               {date} &copy; PULT.RU Все права защищены.
            </p>
         </div>
      </footer>
   );
}

export default Footer;
